import { Block } from 'shared/components/Block';
import { Description } from 'shared/components/Description';
import { NavigationButtons } from 'shared/components/NavigationButtons';
import { Title } from 'shared/components/Title';
import { DESCRIPTION } from './constants';
import { Element } from 'react-scroll';
import { ENavigation } from 'shared/types/navigation';
import { BTN_CORE_BUSINESS_LINK, BTN_DAILY_LINK, BTN_TRANSACTIONAL_LINK } from 'shared/constants/links';

export const Cybersecurity: React.FC = () => {
  return (
    <div>
      <Element name={ENavigation.Cybersecurity}>
        <Block>
          <Title text="Кибербезопасность" />
          <Description text={DESCRIPTION} />
        </Block>
      </Element>
      <NavigationButtons links={[BTN_CORE_BUSINESS_LINK, BTN_TRANSACTIONAL_LINK, BTN_DAILY_LINK]} withOutMarginBottom />
    </div>
  );
};
